import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./style.css";
import { toast } from "react-toastify";

const Popup2FA = ({
  open,
  handleClose,
  displayData,
  twoFactorData,
  handleClick,
  handleOpenLostLine,
}) => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);

  const handleCodeChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;

      setCode(newCode);
      if (value && index < 5) {
        const nextInput = document.getElementById(`code-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
      if (value && index === 5) {
        const otp = newCode.join("");
        handleClick(otp);
      }
    }
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      const prevInput = document.getElementById(`code-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleCopyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    toast.success("Secret key copied to clipboard!");
  };

  return (
    <>
      <Modal className="modal-2fa" isOpen={open} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>{displayData.header}</ModalHeader>

        <ModalBody>
          {twoFactorData?.twoFactorAuthEnabled ? (
            <p className="text-center font-semibold">
              {displayData.title || ""}{" "}
            </p>
          ) : (
            <div>
              <div className="text-center mb-4">
                <div className="qr-code-box">
                  <img src={twoFactorData.qrImage} alt="QR Code" />
                </div>
              </div>

              <div className="secret-key-box mb-3">
                <div className="secret-key-label">Secret Key</div>
                <div className="secret-key-value">
                  {twoFactorData?.tempTwoFactorSecret || ""}
                </div>
                <button
                  onClick={() =>
                    handleCopyToClipboard(twoFactorData?.tempTwoFactorSecret)
                  }
                  className="copy-btn">
                  Copy to clipboard
                </button>
              </div>
            </div>
          )}
          <p className="instructions-text mb-4">{displayData.desc}</p>

          <div>
            <div className="code-input-label">{displayData.tagLine}</div>
            <div className="code-inputs-wrapper">
              {code.map((digit, index) => (
                <React.Fragment key={index}>
                  <input
                    id={`code-${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleCodeChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className="form-control code-input"
                  />
                  {index < 5 && <span className="code-separator">-</span>}
                </React.Fragment>
              ))}
            </div>
            <p className="code-help-text">
              Enter the 6-digit code from your authenticator app.
            </p>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="d-flex justify-content-center w-100">
            <Button onClick={handleClose} color="secondary" className="mr-2">
              {displayData.nextBtnText}
            </Button>
            <Button className="btn-enable-2fa" color="primary">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                style={{ display: "inline-block", verticalAlign: "middle" }}>
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              {displayData.btnText}
            </Button>
          </div>
          {displayData.lostline ? (
            <div className="d-flex justify-content-center w-100">
              <button className="lostaccount-link" onClick={handleOpenLostLine}>
                {displayData.lostline}
              </button>
            </div>
          ) : null}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Popup2FA;
